


















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dialogViewVenta from '@/components/dialogViewVenta.vue'

@Component ({
  components: {
    dialogViewVenta
  }
})
export default class DialogNewBoleto extends Vue {
  @Prop() private msg!: string
  private dialog: boolean = false
  private infoVenta: object = {}
  private headers: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Comprador', value: 'comprador' },
    { text: 'Boletos', value: 'boletos' },
    { text: 'Metodo de Pago', value: 'metodo' },
    { text: 'Monto', value: 'total' },
    { text: 'Acciones', value: 'acciones' }
  ]
  private desserts: any[] = [
    {
      fecha: '08/08/2019',
      comprador: 'Fulanito de Tal',
      boletos: [
        'Infantil - 2000000001',
        'Infantil - 2000000002',
        'Adulto - 1000000001',
        'Adulto - 1000000002'
      ],
      metodo: 'OXXO',
      total: 540,
      status: 'Pendiente'
    },
    {
      fecha: '09/08/2019',
      comprador: 'Manganito de Tal',
      boletos: [
        'Adulto - 1000000003',
        'Infantil - 2000000003'
      ],
      metodo: 'Tarjeta Debito',
      total: 270,
      status: 'Confirmado'
    },
    {
      fecha: '10/08/2019',
      comprador: 'Sutanito de Tal',
      boletos: [
        'Adulto - 1000000001',
        'Infantil - 2000000003',
        '+65 y Discapacidad - 3000000001'
      ],
      metodo: 'Tarjeta Credito',
      total: 370,
      status: 'Confirmado'
    }
  ]
}
